import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    anonimizarNome,
} from '../../../business-components/String/String'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellBodyExibeDadosTitulo,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    DivFormEstudo,
} from '../../../business-components/Div/Div'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import familiaresList from '../../../business-rules/List/familiaresList'



const EstudoReportConferenciaDadosFamiliares = ( { values, report, vars } ) => {

    const aumentoLetraCabecalho = 2
    const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 1
    
    const aumentoLetra = 2
    const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 2 : 1
    
    let headList = [
        {
            colSpan: 6,
            headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.nome, report, null, aumentoLetraCabecalho,
                aumentoLetraReportCabecalho, values),
        },
        //{
        //    colSpan: 3,
        //   headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.nomeCurto, report, null, aumentoLetraCabecalho,
        //        aumentoLetraReportCabecalho, values),
        //},
    ]

    if (!vars.jsonConfiguracao.anonimizarRelatorio || !report || values.modoApresentacao) {

        headList.push(
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.cpf, report, null, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
        )
    }

    headList.push(
        {
            colSpan: 3,
            headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.nascimento, report, null, aumentoLetraCabecalho,
                aumentoLetraReportCabecalho, values),
        },
        {
            colSpan: 2,
            headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.idade, report, null, aumentoLetraCabecalho,
                aumentoLetraReportCabecalho, values),
        },
        {
            colSpan: 3,
            headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.sexo, report, null, aumentoLetraCabecalho,
                aumentoLetraReportCabecalho, values),
        },
        {
            colSpan: 3,
            headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.parentesco, report, null, aumentoLetraCabecalho,
                aumentoLetraReportCabecalho, values),
        },
    )



    return (
        values.familiares && values.familiares.length > 0
            ?
                <DivFormEstudo>
                    <div
                        align="center"
                        className={CLASSNAME().formataReportConferenciaDadosCabecalho + ' mt-5'} // mudança da fonte: inclusão mt-5
                    >
                        {LABEL.familiares.toUpperCase() /* mudança da fonte: uppercase */}
                    </div>

                    <CardGridDivBody>
                        <TableExibeDados
                            report={report}
                            noMinW={true} // tratamento para não ter diferenciação do tamanho de letra no relatório
                        >
                            <TableHeadExibeDados
                                report={report}
                            >
                                <TableRowHeadExibeDados
                                    dados={headList}
                                />
                            </TableHeadExibeDados>

                            <TableBodyExibeDados>
                                {familiaresList(values)?.map((item, ind) => {

                                    let colSpan = 0

                                    return /*item.id > HARDCODE.idFamiliarConjuge &&*/ !pesquisaList(values.exclusaoFamiliares, item.id).id ? (
                                        <TableRowBodyExibeDados
                                            key={ind}
                                            report={report}
                                        >
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                                primeiraColuna={true}
                                            >
                                                {formataTableCellBodyExibeDadosTitulo(
                                                    !vars.jsonConfiguracao.anonimizarRelatorio || !report || values.modoApresentacao
                                                        ?
                                                            item.nome
                                                        :
                                                            anonimizarNome(item.nome),
                                                    report, null, null, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                            
                                            {/*
                                            <TableCellBodyExibeDados
                                                colSpan={headList[1].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTitulo(item.descricao, report,
                                                    null, null, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                            */}
                                            
                                            {(!vars.jsonConfiguracao.anonimizarRelatorio || !report || values.modoApresentacao) && (
                                                <TableCellBodyExibeDados
                                                    colSpan={headList[colSpan++].colSpan}
                                                >
                                                    {formataTableCellBodyExibeDadosTitulo(item.cpfFormatado, report,
                                                        null, null, aumentoLetra, aumentoLetraReport, values)}
                                                </TableCellBodyExibeDados>
                                            )}
                                            
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTitulo(item.nascimentoFormatado,
                                                    report, null, null, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTitulo(item.idade, report, null, null,
                                                    aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>

                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTitulo(item.sexoDescricao, report,
                                                    null, null, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                            
                                            <TableCellBodyExibeDados
                                                colSpan={headList[colSpan++].colSpan}
                                            >
                                                {formataTableCellBodyExibeDadosTitulo(item.parentescoDescricao,
                                                    report, null, null, aumentoLetra, aumentoLetraReport, values)}
                                            </TableCellBodyExibeDados>
                                        </TableRowBodyExibeDados>
                                    )
                                    :
                                    (
                                        <TableRowBodyExibeDados
                                            key={ind}
                                            report={report}
                                        />
                                    )
                                })}
                            </TableBodyExibeDados>
                        </TableExibeDados>
                    </CardGridDivBody>
                </DivFormEstudo>
            :
                ''
    )
}

export default EstudoReportConferenciaDadosFamiliares